module.exports = __webpack_public_path__ + "img/logo.60674ee7.png";